import { defineMessages } from '../translate';

/** Split from `billing` so the always-loaded entry chunk carries only these strings. */
export default defineMessages('billing-upgrade', {
  manageSubscription: 'Manage subscription',
  free: 'Free',
  slashMonth: '/ month',
  limitReachedBadge: 'Limit reached',
  maybeLater: 'Maybe later',
  stripeSoon: 'Stripe checkout is wiring soon — for now contact your admin to upgrade. Bug reports / feedback welcomed.',
  memberLimitTitle: 'Member limit reached',
  projectLimitTitle: 'Project limit reached',
  storageLimitTitle: 'Storage limit reached',
  fileTooLargeTitle: 'File too large',
  memberLimitBody: 'Your plan allows up to {max} members. You currently have {current}. Upgrade to invite more teammates.',
  projectLimitBody: 'Your plan allows up to {max} projects. You currently have {current}. Upgrade for unlimited projects.',
  storageLimitBody: 'Your plan has {max} of storage; {current} already used. Upgrade for more space.',
  fileTooLargeBody: "File size {current} exceeds your plan's per-file cap of {max}. Upgrade for bigger uploads.",
  featMembers: 'Members',
  featProjects: 'Projects',
  featStorage: 'Storage',
  featMaxFileSize: 'Max file size',
  featGithub: 'GitHub integration',
  featCustomRoles: 'Custom roles',
  featAuditLog: 'Audit log',
  featLabel: '{label}:',
  unlimited: 'Unlimited',
  upTo: 'Up to {n}',
  perSeat: '{size} per seat',
  unitB: '{n} B',
  unitKB: '{n} KB',
  unitMB: '{n} MB',
  unitGB: '{n} GB',
  unitTB: '{n} TB',
  unitPB: '{n} PB',
} as const);
